import { PersonOutlinedIcon } from '../icons';
import LoadingSpinner from '../loading-spinner';

export default function UserProfileAvatar({
  imageUrl,
  isLoading,
}: {
  imageUrl?: string;
  isLoading?: boolean;
}) {
  return (
    <div className='flex size-50 items-center justify-center rounded-full bg-gray-100'>
      {isLoading ? (
        <LoadingSpinner />
      ) : imageUrl ? (
        <img src={imageUrl} alt='User Face' className='aspect-square rounded-full object-cover' />
      ) : (
        <PersonOutlinedIcon className='text-[80px] text-gray-400' />
      )}
    </div>
  );
}
